var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGenderIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 1.66663H5C3.61667 1.66663 2.5 2.77496 2.5 4.14163V13.2333C2.5 14.6 3.61667 15.7166 5 15.7166H5.63333C6.29167 15.7166 6.93333 15.975 7.4 16.4416L8.825 17.85C9.475 18.4916 10.525 18.4916 11.175 17.85L12.6 16.4416C13.0667 15.975 13.7083 15.7166 14.3667 15.7166H15C16.3833 15.7166 17.5 14.6 17.5 13.2333V4.14163C17.5 2.77496 16.3833 1.66663 15 1.66663ZM10 4.62496C10.9 4.62496 11.625 5.35829 11.625 6.24996C11.625 7.13329 10.925 7.84163 10.0583 7.87496C10.025 7.87496 9.975 7.87496 9.93333 7.87496C9.05833 7.84163 8.36667 7.13329 8.36667 6.24996C8.375 5.35829 9.1 4.62496 10 4.62496ZM12.2917 12.2416C11.0333 13.0833 8.96667 13.0833 7.70833 12.2416C6.6 11.5083 6.6 10.2916 7.70833 9.54996C8.975 8.70829 11.0417 8.70829 12.2917 9.54996C13.4 10.2916 13.4 11.5 12.2917 12.2416Z",
    fill: "#646D69"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenderIcon);
export default __webpack_public_path__ + "static/media/gender_icon.9ed47944b0a4767c66bd009e17fe5287.svg";
export { ForwardRef as ReactComponent };